import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_BASE_URL } from "../../config";

export const getAllProducts = createAsyncThunk(
  "product/getAllProducts",
  async (token, thunkAPI) => {
    try {
      const response = await fetch(`${API_BASE_URL}/products`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response?.json();
        return thunkAPI.rejectWithValue(errorData?.message); // Use the error message from the server response
      }

      return await response.json();
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Something went wrong. Please try again later."
      );
    }
  }
);

export const getTopRatedProducts = createAsyncThunk(
  "product/getTopRatedProducts",
  async (token, thunkAPI) => {
    try {
      const response = await fetch(`${API_BASE_URL}/top-rated-products`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response?.json();
        return thunkAPI.rejectWithValue(errorData?.message); // Use the error message from the server response
      }

      return await response.json();
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Something went wrong. Please try again later."
      );
    }
  }
);
export const getTopSellingProducts = createAsyncThunk(
  "product/getTopSellingProducts",
  async (token, thunkAPI) => {
    try {
      const response = await fetch(`${API_BASE_URL}/top-selling-products`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response?.json();
        return thunkAPI.rejectWithValue(errorData?.message); // Use the error message from the server response
      }

      return await response.json();
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Something went wrong. Please try again later."
      );
    }
  }
);
export const getRecentlyAddedProducts = createAsyncThunk(
  "product/getRecentlyAddedProducts",
  async (token, thunkAPI) => {
    try {
      const response = await fetch(`${API_BASE_URL}/recently-added-products`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response?.json();
        return thunkAPI.rejectWithValue(errorData?.message); // Use the error message from the server response
      }

      return await response.json();
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Something went wrong. Please try again later."
      );
    }
  }
);
export const getCategoryWiseProducts = createAsyncThunk(
  "product/getCategoryWiseProducts",
  async (payload, thunkAPI) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/products/${payload.category}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${payload.token}`,
          },
        }
      );

      if (!response.ok) {
        const errorData = await response?.json();
        return thunkAPI.rejectWithValue(errorData?.message); // Use the error message from the server response
      }

      return await response.json();
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Something went wrong. Please try again later."
      );
    }
  }
);
export const reviewProduct = createAsyncThunk(
  "product/reviewProduct",
  async (payload, thunkAPI) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/review-product/${payload.productId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${payload.token}`,
          },
          body: JSON.stringify(payload.data),
        }
      );

      if (!response.ok) {
        const errorData = await response?.json();
        return thunkAPI.rejectWithValue(errorData?.message); // Use the error message from the server response
      }

      return await response.json();
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Something went wrong. Please try again later."
      );
    }
  }
);

export const getTrendingProducts = createAsyncThunk(
  "product/getTrendingProducts",
  async (token, thunkAPI) => {
    try {
      const response = await fetch(`${API_BASE_URL}/trending-products`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response?.json();
        return thunkAPI.rejectWithValue(errorData?.message); // Use the error message from the server response
      }

      return await response.json();
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Something went wrong. Please try again later."
      );
    }
  }
);

export const compareProduct = createAsyncThunk(
  "product/compareProduct",
  async (payload, thunkAPI) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/compare-product?productId=${payload?.productId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${payload?.token}`,
          },
        }
      );

      if (!response.ok) {
        const errorData = await response?.json();
        return thunkAPI.rejectWithValue(errorData?.message); // Use the error message from the server response
      }

      return await response.json();
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Something went wrong. Please try again later."
      );
    }
  }
);

const productSlice = createSlice({
  name: "product",
  initialState: {
    products: localStorage.getItem("products")
      ? JSON.parse(localStorage.getItem("products"))
      : [],
    trendingProducts: localStorage.getItem("trendingProducts")
      ? JSON.parse(localStorage.getItem("trendingProducts"))
      : [],
    recentlyAddedProducts: localStorage.getItem("recentlyAddedProducts")
      ? JSON.parse(localStorage.getItem("recentlyAddedProducts"))
      : [],
    topSellingProducts: localStorage.getItem("topSellingProducts")
      ? JSON.parse(localStorage.getItem("topSellingProducts"))
      : [],
    topRatedProducts: localStorage.getItem("topRatedProducts")
      ? JSON.parse(localStorage.getItem("topRatedProducts"))
      : [],
    loading: false,
    trendingLoading: false,
    recentlyAddedLoading: false,
    topSellingLoading: false,
    topRatedLoading: false,
    error: false,
    reviewLoading: false,
    compareLoading: false,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllProducts.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(getAllProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.error = false;
        state.products = [...action.payload.products];
        localStorage.setItem(
          "products",
          JSON.stringify(action.payload.products)
        );
      })
      .addCase(getAllProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
      })
      .addCase(getTopRatedProducts.pending, (state) => {
        state.topRatedLoading = true;
      })
      .addCase(getTopRatedProducts.fulfilled, (state, action) => {
        state.topRatedLoading = false;
        state.topRatedProducts = [...action.payload.products];
        localStorage.setItem(
          "topRatedProducts",
          JSON.stringify(action.payload.products)
        );
      })
      .addCase(getTopRatedProducts.rejected, (state, action) => {
        state.topRatedLoading = false;
      })
      .addCase(getTopSellingProducts.pending, (state) => {
        state.topSellingLoading = true;
      })
      .addCase(getTopSellingProducts.fulfilled, (state, action) => {
        state.topSellingLoading = false;
        state.topSellingProducts = [...action.payload.products];
        localStorage.setItem(
          "topSellingProducts",
          JSON.stringify(action.payload.products)
        );
      })
      .addCase(getTopSellingProducts.rejected, (state, action) => {
        state.topSellingLoading = false;
      })
      .addCase(getRecentlyAddedProducts.pending, (state) => {
        state.recentlyAddedLoading = true;
      })
      .addCase(getRecentlyAddedProducts.fulfilled, (state, action) => {
        state.recentlyAddedLoading = false;
        state.recentlyAddedProducts = [...action.payload.products];
        localStorage.setItem(
          "recentlyAddedProducts",
          JSON.stringify(action.payload.products)
        );
      })
      .addCase(getRecentlyAddedProducts.rejected, (state, action) => {
        state.recentlyAddedLoading = false;
      })
      .addCase(getTrendingProducts.pending, (state) => {
        state.trendingLoading = true;
      })
      .addCase(getTrendingProducts.fulfilled, (state, action) => {
        state.trendingLoading = false;
        state.trendingProducts = [...action.payload.products];
        localStorage.setItem(
          "trendingProducts",
          JSON.stringify(action.payload.products)
        );
      })
      .addCase(getTrendingProducts.rejected, (state, action) => {
        state.trendingLoading = false;
      })
      .addCase(getCategoryWiseProducts.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCategoryWiseProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.products = [...action.payload.products];
      })
      .addCase(getCategoryWiseProducts.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(reviewProduct.pending, (state) => {
        state.reviewLoading = true;
      })
      .addCase(reviewProduct.fulfilled, (state, action) => {
        state.reviewLoading = false;
      })
      .addCase(reviewProduct.rejected, (state, action) => {
        state.reviewLoading = false;
      })
      .addCase(compareProduct.pending, (state) => {
        state.compareLoading = true;
      })
      .addCase(compareProduct.fulfilled, (state, action) => {
        state.compareLoading = false;
        console.log("========ACTION=========", action.payload);
        // state.compareProducts = action.payload
      })
      .addCase(compareProduct.rejected, (state, action) => {
        state.compareLoading = false;
      });
  },
});

export default productSlice.reducer;
